import * as constants from './constants';

// Fetch nearby pins
export const fetchNearbyPinsRequest = (lat, lng, radiusKm = 10) => ({
  type: constants.FETCH_NEARBY_PINS_REQUEST,
  payload: { lat, lng, radiusKm },
});

export const fetchNearbyPinsSuccess = (data) => ({
  type: constants.FETCH_NEARBY_PINS_SUCCESS,
  payload: data,
});

export const fetchNearbyPinsFailure = (error) => ({
  type: constants.FETCH_NEARBY_PINS_FAILURE,
  payload: error,
});

// Fetch tour map data
export const fetchTourMapRequest = (tourId) => ({
  type: constants.FETCH_TOUR_MAP_REQUEST,
  payload: { tourId },
});

export const fetchTourMapSuccess = (data) => ({
  type: constants.FETCH_TOUR_MAP_SUCCESS,
  payload: data,
});

export const fetchTourMapFailure = (error) => ({
  type: constants.FETCH_TOUR_MAP_FAILURE,
  payload: error,
});

// Set user location (from GPS)
export const setUserLocation = (lat, lng) => ({
  type: constants.SET_USER_LOCATION,
  payload: { lat, lng },
});

// Set map center (when user pans map)
export const setMapCenter = (lat, lng) => ({
  type: constants.SET_MAP_CENTER,
  payload: { lat, lng },
});

// Set map zoom level
export const setMapZoom = (zoom) => ({
  type: constants.SET_MAP_ZOOM,
  payload: { zoom },
});

// Select a pin on the map
export const selectPin = (pin) => ({
  type: constants.SELECT_PIN,
  payload: pin,
});

// Clear selected pin
export const clearSelectedPin = () => ({
  type: constants.CLEAR_SELECTED_PIN,
});
